define('dealerLiveChat',[
  'jquery',
  'webStorage',
  'zipTools',
  'lib/util/tda.config',
  'lib/util/zip',
  'lib/util/langFromUrl',
  'cookies'
], function (
  $,
  WebStorage,
  zipTools,
  tdaConfig,
  zip,
  langFromUrl,
  cookies
) {
  // in place on dealer-detail, offer-detail, vehicle-info, inventory-detail pages.
  // used when chat with dealer CTA is present on page via Tools DCR.
  // BAT-2616, pretty much same deal as "Visit Dealer Website" CTA's (dealer-specials.js)
  // note that we save a cookie if a user selects a dealer
  var dealerLiveChat = dealerLiveChat || {
    saveSelected: true, // set to false if we want to replicate the Visit Dealer Site CTA. Set to true if we only want user to select a dealer once.

    init: function (providerId) {
      var self = this;
      // KAC-77 KAC https://api.selltoyotas.com/inventory/bat/bat_script_v2.js puts us right back in here even though BAT does not. do not let that happen!
      if ('KAC10' === tdaConfig.tda.code) return;

      // $('a[data-destination="schedule-a-test-drive"]').attr('id', 'live-chat').addClass('js-live-chat');
      $('a[data-destination="live-chat"]').addClass('js-live-chat');
      var $ctdButton = $('.js-live-chat');
      if ($ctdButton.length) {
        var newZip = zip.getCookiedDefaultFallback();
        var pmaDealerCodes = '';

        // get TDA for new zip
        zipTools.getTDA(newZip, function (pmaDealers) {
          // check that dealers were returned
          if (pmaDealers && pmaDealers.entityList && pmaDealers.entityList.length) {
            var confirmDealerTemplateData;
            var newDealer;
            var clickDealerTemplateData;
            // for testing, add another pmaDealer
            // pmaDealers.entityList[1].pma = true;

            var finalDealers = self.getPMADealers(newZip, pmaDealers);

            // if there's more than one PMA Dealer:
            if (finalDealers.length > 1) {
              // Display Select Dealer Modal if it's in the URL params
              var showDealersParam = location.href.indexOf('showDealersChat');
              if (showDealersParam !== -1) {
                var savedDealerCode = cookies.getItem('dealer_code_cao');
                if (self.saveSelected && savedDealerCode && cookies.getItem('isConfirmedZip') === 'true') {
                  // user previously selected a dealer, don't display select modal even its in URL params
                } else {
                  pmaDealerCodes = '';
                  clickDealerTemplateData = zipTools._getConfirmDealerTemplateData(finalDealers);
                  for (var x = 0; x < finalDealers.length; x++) {
                    pmaDealerCodes = pmaDealerCodes + finalDealers[x].dealerCode + ',';
                  }
                  if ($('#ctdealer-modal').length === 0) {
                    zipTools.showClickDealerModal(clickDealerTemplateData, function (newDealerUrl) {});
                    $('#modal-click-to-dealer').addClass('modal-has-header').show();
                    $('#js-modal-dealer-intro').hide();
                    $('#js-modal-dealer-results-live-chat').show();
                  }
                }
              }

              $('.js-live-chat').on('click', function (e) {
                e.preventDefault();
                var savedDealerCode = cookies.getItem('dealer_code_cao');
                if (self.saveSelected && savedDealerCode && cookies.getItem('isConfirmedZip') === 'true') {
                  self.clickSelectDealer(savedDealerCode, this);
                } else {
                  // confirmed zip, show results
                  if (cookies.getItem('isConfirmedZip') === 'true') {
                    pmaDealerCodes = '';
                    clickDealerTemplateData = zipTools._getConfirmDealerTemplateData(finalDealers);
                    for (var x = 0; x < finalDealers.length; x++) {
                      pmaDealerCodes = pmaDealerCodes + finalDealers[x].dealerCode + ',';
                    }
                    zipTools.showClickDealerModal(clickDealerTemplateData, function (newDealerUrl) {});
                    $('#modal-click-to-dealer').addClass('modal-has-header').show();
                    $('#js-modal-dealer-intro').hide();
                    $('#js-modal-dealer-results-live-chat').show();
                  } else {
                    clickDealerTemplateData = zipTools._getConfirmDealerTemplateData(finalDealers);
                    zipTools.showClickDealerModal(clickDealerTemplateData, function (newDealerUrl) {});
                    $('#modal-click-to-dealer').removeClass('modal-has-header').show();
                    $('#js-modal-dealer-results-live-chat').hide();
                    $('#js-modal-dealer-intro').show();
                  }
                }
              });

            // If there's only a single PMA dealer
            } else {
              var showDealersParam = location.href.indexOf('showDealersChat');
              // if showDealersParam is present
              if (showDealersParam !== -1) {
                var savedDealerCode = cookies.getItem('dealer_code_cao');
                if (self.saveSelected && savedDealerCode && cookies.getItem('isConfirmedZip') === 'true') {
                  // user previously selected a dealer, don't display select modal even its in URL params
                } else if (cookies.getItem('isConfirmedZip') === 'true') {
                  // unconfirmed zip, prompt even if there's only a single dealer
                  pmaDealerCodes = '';
                  clickDealerTemplateData = zipTools._getConfirmDealerTemplateData(finalDealers);
                  for (var x = 0; x < finalDealers.length; x++) {
                    pmaDealerCodes = pmaDealerCodes + finalDealers[x].dealerCode + ',';
                  }
                  if ($('#ctdealer-modal').length === 0) {
                    zipTools.showClickDealerModal(clickDealerTemplateData, function (newDealerUrl) {});
                    $('#modal-click-to-dealer').addClass('modal-has-header').show();
                    $('#js-modal-dealer-intro').hide();
                    $('#js-modal-dealer-results-live-chat').show();
                  }
                }
              }

              if (cookies.getItem('isConfirmedZip') === 'true') {
                var singleDealerCode = finalDealers[0].dealerCode;
                // zip is confirmed, and we only have a single dealer. set the cookie
                if (self.saveSelected) {
                  var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
                  cookies.setItem('dealer_code_cao', String(singleDealerCode), oneYear, '/', zipTools.getCrossDomainCookieDomain());
                }

                $('.js-live-chat').on('click', function (e) {
                  e.preventDefault();
                  var savedDealerCode = cookies.getItem('dealer_code_cao');
                  if (self.saveSelected && savedDealerCode && cookies.getItem('isConfirmedZip') === 'true') {
                    self.clickSelectDealer(savedDealerCode, this);
                  } else {
                    // re-check if isConfirmed, need to do this ON CLICK!!
                    if (cookies.getItem('isConfirmedZip') === 'true') {
                      pmaDealerCodes = '';
                      clickDealerTemplateData = zipTools._getConfirmDealerTemplateData(finalDealers);
                      for (var x = 0; x < finalDealers.length; x++) {
                        pmaDealerCodes = pmaDealerCodes + finalDealers[x].dealerCode + ',';
                      }
                    }
                    zipTools.showClickDealerModal(clickDealerTemplateData, function (newDealerUrl) {});
                    $('#modal-click-to-dealer').addClass('modal-has-header').show();
                    $('#js-modal-dealer-intro').hide();
                    $('#js-modal-dealer-results-live-chat').show();
                  }
                });
              } else {
                $('.js-live-chat').on('click', function (e) {
                  e.preventDefault();
                  if (cookies.getItem('isConfirmedZip') === 'true') {
                    pmaDealerCodes = '';
                    for (var x = 0; x < finalDealers.length; x++) {
                      pmaDealerCodes = pmaDealerCodes + finalDealers[x].dealerCode + ',';
                    }
                    clickDealerTemplateData = zipTools._getConfirmDealerTemplateData(finalDealers);
                    zipTools.showClickDealerModal(clickDealerTemplateData, function (newDealerUrl) {});
                    $('#modal-click-to-dealer').addClass('modal-has-header').show();
                    $('#js-modal-dealer-intro').hide();
                    $('#js-modal-dealer-results-live-chat').show();
                  } else {
                    clickDealerTemplateData = zipTools._getConfirmDealerTemplateData(finalDealers);
                    zipTools.showClickDealerModal(clickDealerTemplateData, function (newDealerUrl) {});
                    $('#modal-click-to-dealer').removeClass('modal-has-header').show();
                    $('#js-modal-dealer-results-live-chat').hide();
                    $('#js-modal-dealer-intro').show();
                  }
                });
              }
            }
            // complete the dealer site change
          }
        });

        $(window).on('ZIP_CODE_CHANGED', function () {
          cookies.removeItem('dealer_code_cao', '/', zipTools.getCrossDomainCookieDomain());
          $('.js-live-chat').off('click');
          self.init();
        });

        $ctdButton.fadeIn(); // hidden by default via inline CSS
      }
    },
    // Modified for NCA-76 and NCA-78 - Ends

    getPMADealers: function (newZip, pmaDealers) {
      var tmpFinalDealers = [];
      $.ajax({
        dataType: 'json',
        url: '/BATWS/geo/rest/searchMode/getDealerDetails',
        async: false,
        data: {
          zipcode: newZip,
          begin: 1,
          brand: WebStorage.getSessionStorage().getItem('brand'),
          // current logic makes one request per dealer code
          end: 6
          // end: dealerCodes.length
        },
        beforeSend: function (xhrObj) {
          xhrObj.setRequestHeader('Content-Type', 'application/json');
          xhrObj.setRequestHeader('Accept', 'application/json');
          xhrObj.overrideMimeType('application/json');
        }
      }).done(function (data) {
        for (x = 0; x < pmaDealers.entityList.length; x++) {
          if (pmaDealers.entityList[x].pma == true || pmaDealers.entityList[x].pma == 'true') {
            for (i = 0; i < data.dealerLocator.length; i++) {
              if (data.dealerLocator[i].dealerId == pmaDealers.entityList[x].dealerCode) {
                pmaDealers.entityList[x].dealerLocator = data.dealerLocator[i];
                tmpFinalDealers.push(pmaDealers.entityList[x]);
              }
            }
          }
        }
        if (pmaDealers.entityList.length != 0 && tmpFinalDealers.length == 0) {
          for (y = 0; y < pmaDealers.entityList.length; y++) {
            for (j = 0; j < data.dealerLocator.length; j++) {
              if (data.dealerLocator[j].dealerId == pmaDealers.entityList[y].dealerCode) {
                pmaDealers.entityList[y].dealerLocator = data.dealerLocator[j];
                tmpFinalDealers.push(pmaDealers.entityList[y]);
              }
            }
          }
        }
      }).fail(function (jqXHR, textStatus, errorThrown) {
        // console.log('ERROR');
        // console.log(textStatus, errorThrown);
        // self.handleServiceError();
      });

      return tmpFinalDealers;
    },

    clickSelectDealer: function (dealerCode, current) {
      if (this.saveSelected) {
        var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
        cookies.setItem('dealer_code_cao', String(dealerCode), oneYear, '/', zipTools.getCrossDomainCookieDomain());
      }
      var providerId = tdaConfig.chat.provider_id;
      var chatUrl = '//buyatoyota.contactatonce.com/caoclientcontainer.aspx?ProviderId=' + providerId + '&MerchantId=' + dealerCode + '&PlacementId=1&OriginationUrl=' + encodeURIComponent(location.href);
      window.open(chatUrl, 'CAO', 'resizable=yes,toolbar=no,menubar=no,location=no,scrollbars=no,status=no,height=400,width=600');
    },

    // Added for NCA-76 and NCA-78 - Starts
    findDealersByZip: function () {
      var self = this;
      var currentZip = zip.getCookiedDefaultFallback();
      var newZipEntered = $('#find-a-dealer-search-value').val();
      var redirectUrl = null;
      var responseType = '';
      var newTDACode = tdaConfig.tda.code;
      var validZip = zipTools.isValidNewZip(currentZip, newZipEntered);

      if (!validZip) {
        $('.close-ground').trigger('click');
        zipTools.showInvalidZipModal(currentZip, newZipEntered, '', '', false);
        return false;
      }
      // add a loader
      $('#modal-click-to-dealer').find('.modal-dialog').append('<div class="loader"></div>');

      // For BAT-1007
      $.ajax({
        dataType: 'json',
        url: '/BATWS/geo/rest/geoLocation/getGeoInfo',
        data: {
          zipcode: newZipEntered
        },
        success: function (data, textStatus, xhr) {},
        error: function (request, error) {
          responseType = 'xml';
        }
      }).done(function (data) {
        newTDACode = data.entityList[0].tdaCode;
        if (data.serviceError != null) {
          redirectUrl = null; // a new serviceError has been returned, reset global redirectUrl
          if (data.serviceError != null && data.serviceError.redirect != null && data.serviceError.redirect.redirectUrl != null) {
            redirectUrl = data.serviceError.redirect.redirectUrl;
          } else if (data.serviceError != null && data.serviceError.Redirect != null && data.serviceError.Redirect.redirectUrl != null) {
            redirectUrl = data.serviceError.Redirect.redirectUrl;
          }
        }

        if (newZipEntered != '' && newZipEntered != null && typeof newZipEntered !== 'undefined' && $.trim(newZipEntered) != '') {
          if (tdaConfig.tda.code == newTDACode) {
            if (redirectUrl == null) {
              zipTools.getTDA(newZipEntered, function (pmaDealersNew) {
                var finalDealersNew = self.getPMADealers(newZipEntered, pmaDealersNew);
                var dealersLength = finalDealersNew.length;
                if (dealersLength > 0) {
                  cookies.setItem('zip', String(newZipEntered), new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
                  cookies.setItem('zipcode', String(newZipEntered), new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
                  cookies.setItem('isConfirmedZip', 'true', new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
                  pmaDealerCodes = '';
                  for (var y = 0; y < finalDealersNew.length; y++) {
                    pmaDealerCodes = pmaDealerCodes + finalDealersNew[y].dealerCode + ',';
                  }
                  // if there are params in URL already, tack ours on
                  if (location.search) {
                    location.href = location.search + '&showDealersChat=true';
                  } else {
                    location.href = '?showDealersChat=true';
                  }
                } else {
                  setTimeout(function () {
                    $('#modal-click-to-dealer').hide();
                    // if zip invalid, show invalid modal
                    zipTools.showInvalidZipModal(zip.getCookiedDefaultFallback(), newZipEntered, '', '', false);
                  }, 300);
                }
              });
            } else {
              $('.modal-backdrop').hide();
              $('#modal-click-to-dealer').hide();
              cookies.setItem('zip', String(newZipEntered), new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
              cookies.setItem('zipcode', String(newZipEntered), new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
              cookies.setItem('isConfirmedZip', 'true', new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
              zipTools.showConfirmZipChangeModal(newZipEntered, false, function () {
                cookies.setItem('transferZip', newZipEntered, new Date(Date.now() + zipTools.transferZipCookieTTL), '/', zipTools.getCrossDomainCookieDomain());
                window.location.href = redirectUrl;
              });
            }
          } else {
            $('.modal-backdrop').hide();
            $('#modal-click-to-dealer').hide();
            zipTools.showConfirmZipChangeModal(newZipEntered, false, function () {
              cookies.setItem('transferZip', newZipEntered, new Date(Date.now() + zipTools.transferZipCookieTTL), '/', zipTools.getCrossDomainCookieDomain());
              cookies.setItem('zip', String(newZipEntered), new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
              cookies.setItem('zipcode', String(newZipEntered), new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
              cookies.setItem('isConfirmedZip', 'true', new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', zipTools.getCrossDomainCookieDomain());
              window.location.href = '/GOTO/' + newTDACode + '/' + langFromUrl() + '/?originating_zip_code=' + currentZip;
            });
          }
        }
      }).fail(function (jqXHR, textStatus, errorThrown) {
        $('#service-error-modal').modal('show');
      });
    }
  };

  // Shim. We rely on this, as we invoke window.dealerLiveChat from within modals. Gosh darn it all anyway.
  window.dealerLiveChat = dealerLiveChat;
  return dealerLiveChat;
});

